// Buy X Get 1 Free progress: keeps every <deal-progress> (cart meter, PDP sale card, announcement bar)
// in step with the cart without a reload. Display only, the discount itself is an automatic
// discount in Shopify. Copy mirrors snippets/deal-status.liquid, keep the two in sync.

const instances = new Set();

const ordinal = (n) => {
  if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
  return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
};

const dealState = (count, goal, repeat) => {
  let free = Math.floor(count / goal);
  const into = count % goal;
  const maxed = !repeat && free >= 1;
  if (maxed) free = 1;
  const unlocked = free > 0 && (into === 0 || maxed);
  return { free, into, needed: goal - into, unlocked, filled: unlocked ? goal : into };
};

const dealText = (count, goal, state, idle, context) => {
  const nth = ordinal(goal);
  if (count === 0) return idle || `Add ${goal} pairs, your ${nth} is free`;
  if (state.free === 0) {
    if (state.needed === 1) return context === 'pdp' ? "Add this pair and it's free" : "Add 1 more pair and it's free";
    return `Add ${state.needed} more pairs, your ${nth} is free`;
  }
  if (state.unlocked) return state.free === 1 ? `Unlocked: your ${nth} pair is free` : `Unlocked: ${state.free} free pairs`;
  const lead = `${state.free} free pair${state.free > 1 ? 's' : ''} unlocked.`;
  return state.needed === 1 ? `${lead} Next pair is free too` : `${lead} Add ${state.needed} more for another`;
};

class DealProgress extends HTMLElement {
  connectedCallback() {
    instances.add(this);
  }

  disconnectedCallback() {
    instances.delete(this);
  }

  update(count) {
    const goal = Math.max(2, parseInt(this.getAttribute('goal'), 10) || 3);
    const state = dealState(count, goal, this.getAttribute('repeat') !== 'false');
    const status = this.querySelector('[data-deal-status]');

    if (status) {
      status.textContent = dealText(count, goal, state, this.getAttribute('idle'), this.getAttribute('context'));
    }

    this.querySelectorAll('[data-deal-seg]').forEach((seg, index) => seg.classList.toggle('is-filled', index < state.filled));
    this.classList.toggle('is-unlocked', state.unlocked);
    this.classList.toggle('is-empty', count === 0);
  }
}

const updateAll = (count) => instances.forEach((instance) => instance.update(count));

const refreshFromServer = async () => {
  try {
    const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    updateAll(cart.item_count);
  } catch (error) {}
};

document.addEventListener('cart:change', (event) => {
  const count = event.detail?.cart?.item_count;
  typeof count === 'number' ? updateAll(count) : refreshFromServer();
});
document.addEventListener('cart:refresh', refreshFromServer);
window.addEventListener('pageshow', (event) => event.persisted && refreshFromServer());

if (!window.customElements.get('deal-progress')) {
  window.customElements.define('deal-progress', DealProgress);
}
